import React from 'react'
import {
  useOpenAssetModal,
  useOpenPlaceModal,
  useOpenServiceOrderModal,
  useOpenUserContractModal
} from '../../../utils/routes/modals/modalsActions'
import { COLORS } from '@btime/constants'
import Icon from '../../shapes/Icon'

export const useOnClick = () => {
  const openModal = useOpenPlaceModal()
  const openAssetModal = useOpenAssetModal()
  const openServiceOrderModal = useOpenServiceOrderModal()
  const openUserContractModal = useOpenUserContractModal()
  return (item, placeTypes) => {
    switch (item.recordType) {
      case 'assets':
        return openAssetModal({ id: item.recordId, name: item.name })
      case 'serviceOrders':
        return openServiceOrderModal({ id: item.recordId, name: item.name }) //TODO ainda não funciona pois precisa do earlyId
      case 'contracts':
        return openUserContractModal({ id: item.recordId, name: item.name })
      default:
        const placeFound = placeTypes.find(placeType => {
          return placeType.key === item.recordType
        })
        if (placeFound) {
          return openModal({ id: item.recordId, name: item.name })
        }
    }
  }
}

export const MapIcon = ({ item, placeTypes, ...props }) => {
  const onClick = useOnClick()
  let icon
  switch (item.recordType) {
    case 'serviceOrders':
      icon = (
        <Icon
          name="RiInboxFill"
          color={COLORS.dark3}
          size="2rem"
          onClick={() => onClick(item, placeTypes)}
          {...props}
        />
      )
      break
    case 'contracts':
      icon = (
        <Icon
          name="RiAccountBoxLine"
          color={COLORS.dark3}
          size="2rem"
          onClick={() => onClick(item, placeTypes)}
          {...props}
        />
      )
      break
    case 'person':
      icon = (
        <Icon
          name="RiUser3Line"
          color={COLORS.dark3}
          size="2rem"
          onClick={() => onClick(item, placeTypes)}
          {...props}
        />
      )
      break
    default:
      const placeFound = placeTypes.find(placeType => {
        return placeType.key === item.recordType
      })
      if (placeFound) {
        icon = (
          <Icon
            name={placeFound.icon}
            color={COLORS.dark3}
            size="2rem"
            onClick={() => onClick(item, placeTypes)}
            {...props}
          />
        )
      } else {
        icon = (
          <Icon
            name="RiMapPin2Line"
            color={COLORS.dark3}
            size="2rem"
            onClick={() => onClick(item, placeTypes)}
            {...props}
          />
        )
      }
  }

  return icon
}
